import { useState, useEffect, useCallback } from 'react';

const useVoiceRecognition = () => {
    const [isListening, setIsListening] = useState(false);
    const [supported, setSupported] = useState(true);
    const [text, setText] = useState('');
    const [recognition, setRecognition] = useState(null);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

            if (SpeechRecognition) {
                const rec = new SpeechRecognition();
                rec.continuous = true; // Susunca hemen durmasın, kayda devam etsin
                rec.interimResults = true; // Ara sonuçları versin ki kullanıcı yazdığını görebilsin
                rec.lang = 'tr-TR';

                rec.onstart = () => {
                    setIsListening(true);
                    setText('');
                };

                rec.onresult = (event) => {
                    let finalTranscript = '';
                    for (let i = event.resultIndex; i < event.results.length; ++i) {
                        if (event.results[i].isFinal) {
                            finalTranscript += event.results[i][0].transcript;
                        }
                    }

                    // Eğer interimResults istenirse burada geçici metin de eklenebilir ama şu an için
                    // sadece final sonuçların birikmesini sağlayalım.
                    if (finalTranscript) {
                        setText((prev) => (prev ? prev + ' ' + finalTranscript : finalTranscript));
                    }
                };

                rec.onerror = (event) => {
                    console.error('Ses Tanıma Hatası:', event.error);
                    setIsListening(false);
                };

                rec.onend = () => {
                    setIsListening(false);
                };

                setRecognition(rec);
            } else {
                setSupported(false);
            }
        }
    }, []);

    const startListening = useCallback(() => {
        if (recognition && !isListening) {
            try {
                setText('');
                recognition.start();
            } catch (err) {
                console.error('Mikrofon başlatılamadı', err);
            }
        }
    }, [recognition, isListening]);

    const stopListening = useCallback(() => {
        if (recognition && isListening) {
            recognition.stop();
        }
    }, [recognition, isListening]);

    return {
        isListening,
        supported,
        text,
        startListening,
        stopListening,
        setText // Manuel sıfırlamak için
    };
};

export default useVoiceRecognition;
